// Go's unicode.IsSpace, written out. A WhatsApp template parameter cannot hold
// a newline, a tab or a long run of spaces, so the worker joins every run to
// one space before it sends (tenant-backend internal/sender/whatsapp_text.go).
// JavaScript's \s is not the same set: it leaves out U+0085 and takes in
// U+FEFF, so it cannot stand in for this class.
const GO_SPACE_RUN =
  /[\t\n\v\f\r \u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]+/g

/** The text a recipient gets for what the operator typed in the WhatsApp panel. */
export const collapseWhitespace = (text: string): string =>
  text.replace(GO_SPACE_RUN, ' ').trim()

// The approved WhatsApp template, as read from Meta's API on 2026-10-13
// (status APPROVED, category UTILITY, parameter format NAMED). The worker
// sends the name and language from its own settings and fills the three named
// parameters (tenant-backend internal/sender/whatsapp.go:154-161). Change the
// wording here and nowhere else.
export const WHATSAPP_TEMPLATE = {
  name: 'important_message_from_the_water_company',
  language: 'he',
  header: 'הודעה מתאגיד המים',
  body: 'שלום {{customer_name}},\n\nלהלן הודעה מתאגיד המים:\n\n{{message}}\n\nבברכה,\n{{water_company}}\n-',
} as const

export const WHATSAPP_PARAMS = [
  ...WHATSAPP_TEMPLATE.body.matchAll(/\{\{([a-z_]+)\}\}/g),
].map(m => m[1])

// water_company is the worker's WHATSAPP_WATER_COMPANY setting, which the
// dashboard cannot read, so the preview shows a marker for it. The name is a
// marker too unless the audience is one consumer.
const NAME_MARKER = '{שם הצרכן}'
const COMPANY_MARKER = '{שם התאגיד}'

/** The body a recipient gets, with the dashboard's markers where it cannot know the value. */
export const renderWhatsappBody = ({
  customerName,
  message,
}: {
  customerName?: string
  message: string
}): string => {
  const values: Record<string, string> = {
    customer_name: customerName || NAME_MARKER,
    message: collapseWhitespace(message),
    water_company: COMPANY_MARKER,
  }
  return WHATSAPP_TEMPLATE.body.replace(
    /\{\{([a-z_]+)\}\}/g,
    (_all, key: string) => values[key]
  )
}
